import Style from "./SearchDate.module.scss";
import { Dropdown } from "react-bootstrap";
import Icons from "../../components/Layouts/Icons";

const SearchDate = ({ searchDate, setSearchDate }) => {
  return (
    <>
      <Dropdown style={{ width: "100%" }}>
        <Dropdown.Toggle>{searchDate}</Dropdown.Toggle>
        <Dropdown.Menu>
          <div
            className={`${Style.search_results_filter_searchbar} form-group`}
          >
            <input
              type="date"
              onChange={(e) => {
                setSearchDate(e.target.value);
              }}
              className="form-control"
              placeholder="Date"
            />
            {/* <Icons icon={"icon-calender"} size={16} /> */}
          </div>
        </Dropdown.Menu>
      </Dropdown>
     
    </>
  );
};

export default SearchDate;
